/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useHistory } from 'react-router';
import logo from '../../../assets/logo2x.png'
import './S2tranNav.scss'


const Nav = ({ backClass}) => {
    let history = useHistory()

    const openNav = () => {
        document.querySelector('.nav-bar').classList.remove('hide') 
        if(backClass) {
            document.querySelector(`.${backClass}`).classList.remove('hide')
        } else {
            document.querySelector('.backgroundh').classList.remove('hide')
        }    
        
    }

    const handleLogoClick = () => {
        window.location = ' https://online.lvzconnect.org/'
    }

    const handleMouseOver = (selector) => {
        document.querySelector(selector).classList.remove('hide')
    }

    const handleMouseLeave = (selector) => {
        document.querySelector(selector).classList.add('hide')
    }

    const handleGive = (e) => {
        e.preventDefault()
        if (document.querySelector('.backgroundh')) {
            document.querySelector('.backgroundh').classList.remove('hide')
        }
        if(backClass) {
            document.querySelector(`.${backClass}`).classList.remove('hide')
        }    
        document.querySelector('.stream-give').classList.remove('hide')
        document.querySelector('.nav-bg').classList.remove('hide')
        document.querySelector('.nav-bar').classList.add('hide') 

    }

    const handleNavBgClick = () =>{
        if (document.querySelector('.backgroundh')) {
            document.querySelector('.backgroundh').classList.add('hide')
        } 
        if (document.querySelector('.lang-c')) {
            document.querySelector('.lang-c').classList.add('hide')
        }
        if (document.querySelector('.stream-form-container')) {
            document.querySelector('.stream-form-container').classList.add('hide')
        }
         
        document.querySelector('.nav-bar').classList.add('hide') 
        document.querySelector('.nav-bg').classList.add('hide') 
        document.querySelector('.stream-give').classList.add('hide') 
    }
    

    return (
        <nav className='frontend-nav'>
           
            <img src={logo} alt="" srcset=""  onClick={handleLogoClick}/>
          
            

            <ul className='mob hamburger' onClick={openNav}>
                <div className='hamburger-line'></div>
                <div className='hamburger-line'></div>
                <div className='hamburger-line'></div>
            </ul>

            <ul className="desk">
                <li className='nav-watch-live'>
                    <a href="https://online.lvzconnect.org/watchlive/">
                        WATCH LIVE
                    </a>
                </li>

                <li onMouseOver={() => handleMouseOver('.live-life')} onMouseLeave={() => handleMouseLeave('.live-life')}>
                    <a href="#" onClick={(e) => {e.preventDefault()}}>
                        LIVE LIFE!
                    </a>
                    <ul className="live-life sub-nav hide">
                        <li>
                            <a href="https://online.lvzconnect.org/media/">
                                SERVICE CATCHUP
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/blog/">
                                HIGHER LIFE
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/shop/">
                                ONLINE STORE
                            </a>
                        </li>
                    </ul>
                </li>

                <li onMouseOver={() => handleMouseOver('.digi-missions')} onMouseLeave={() => handleMouseLeave('.digi-missions')}>
                    <a href="" onClick={(e) => {e.preventDefault()}}>
                        DIGITAL MISSIONS
                    </a>

                    <ul className="digi-missions sub-nav hide">
                        <li>
                            <a href="https://online.lvzconnect.org/events/category/our-events/">
                                GLOBAL OUTREACHES
                            </a>
                        </li>
                        <li>
                            <a href=" https://online.lvzconnect.org/events/">
                                UPCOMING EVENTS
                            </a>
                        </li>
                    </ul>
                </li>

                <li onMouseOver={() => handleMouseOver('.we-care')} onMouseLeave={() => handleMouseLeave('.we-care')}>
                    <a href="#" onClick={(e) => {e.preventDefault()}} >
                        WE CARE!
                    </a>

                    <ul className="we-care sub-nav hide">
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                                FOUNDATION SCHOOL
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                                FRIENSHIP CIRCLE
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                                JOIN CARE MEETING
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                             PRAYER MEETING
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                             LEADERSHIP TRAINING
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                             CAPACITY WEBINARS
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                             MEMBER AREA
                            </a>
                        </li>
                    </ul>
                </li>

                <li onMouseOver={() => handleMouseOver('.about-us')} onMouseLeave={() => handleMouseLeave('.about-us')}>
                    <a href="" onClick={(e) => {e.preventDefault()}}>
                        ABOUT US
                    </a>

                    <ul className="about-us sub-nav hide">
                        <li>
                            <a href=" https://online.lvzconnect.org/our-belief/">
                                WHAT WE BELIEVE
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/our-missions/">
                                WHAT TO EXPECT
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/contacts/">
                                CONTACT US
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/privacy-policy/">
                                 PRIVACY POLICY
                            </a>
                        </li>
                    </ul>
                </li>

                <li className='nav-give' onClick={handleGive}>
                    <a href="" onClick={(e) => {e.preventDefault()}}>
                        GIVE
                    </a>
                </li>
            </ul>

            <ul className="nav-bar mob hide">

                <ul className='mob hamburger' onClick={openNav}>
                    <div className='hamburger-line'></div>
                    <div className='hamburger-line'></div>
                    <div className='hamburger-line'></div>
                </ul>

                <ul className="nav-links">
                    <li className='nav-watch-live'>
                        <a href="https://online.lvzconnect.org/watchlive/">
                            WATCH LIVE
                        </a>
                    </li>

                    <li onMouseOver={() => handleMouseOver('.live-life-mob')} onMouseLeave={() => handleMouseLeave('.live-life-mob')}>
                        <a href="" onClick={(e) => {e.preventDefault()}}>
                            LIVE LIFE!
                        </a>

                        <ul className="live-life-mob sub-nav hide">
                        <li>
                            <a href="https://online.lvzconnect.org/media/">
                                SERVICE CATCHUP
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/blog/">
                                HIGHER LIFE
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/shop/">
                                ONLINE STORE
                            </a>
                        </li>
                    </ul>
                    </li>

                    <li onMouseOver={() => handleMouseOver('.digi-missions-mob')} onMouseLeave={() => handleMouseLeave('.digi-missions-mob')}>
                        <a href="" onClick={(e) => {e.preventDefault()}}>
                            DIGITAL MISSIONS
                        </a>

                        <ul className="digi-missions-mob sub-nav hide">
                        <li>
                            <a href="https://online.lvzconnect.org/events/category/our-events/">
                                GLOBAL OUTREACHES
                            </a>
                        </li>
                        <li>
                            <a href=" https://online.lvzconnect.org/events/">
                                UPCOMING EVENTS
                            </a>
                        </li>
                    </ul>
                    </li>

                    <li onMouseOver={() => handleMouseOver('.we-care-mob')} onMouseLeave={() => handleMouseLeave('.we-care-mob')}>
                        <a href="" onClick={(e) => {e.preventDefault()}}>
                            WE CARE!
                        </a>

                        <ul className="we-care-mob sub-nav hide">
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                                FOUNDATION SCHOOL
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                                FRIENSHIP CIRCLE
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                                JOIN CARE MEETING
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                             PRAYER MEETING
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                             LEADERSHIP TRAINING
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                             CAPACITY WEBINARS
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/connect/">
                             MEMBER AREA
                            </a>
                        </li>
                    </ul>
                    </li>

                    <li onMouseOver={() => handleMouseOver('.about-us-mob')} onMouseLeave={() => handleMouseLeave('.about-us-mob')}>
                        <a href="" onClick={(e) => {e.preventDefault()}}>
                            ABOUT US
                        </a>

                        <ul className="about-us-mob sub-nav hide">
                        <li>
                            <a href=" https://online.lvzconnect.org/our-belief/">
                                WHAT WE BELIEVE
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/our-missions/">
                                WHAT TO EXPECT
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/contacts/">
                                CONTACT US
                            </a>
                        </li>
                        <li>
                            <a href="https://online.lvzconnect.org/privacy-policy/">
                                 PRIVACY POLICY
                            </a>
                        </li>
                    </ul>
                    </li>

                    <li className='nav-give' onClick={handleGive}>
                        <a href="" onClick={(e) => {e.preventDefault()}}>
                            GIVE
                        </a>
                    </li>
                </ul>
                
            </ul>

            <div className="stream-give hide">
                <a href='https://www.kingspayweb.com/quickpay/lvzvc' rel="noreferrer" target='_blank'>Online / Card Payment</a>
                <strong>Offline Payment</strong>
                <em>Bank Transfer or Direct Debit</em>
                <p>Bank: <span>Refuge Mortgage Bank</span></p>
                <p>Account Number: <span>1300077915</span></p>
                <p>Account Name: <span>CC & E Account2</span></p>      
            </div>

            <div className="nav-bg hide" onClick={handleNavBgClick}></div>
            
        </nav>
    )
}

export default Nav